import { arrayMoveImmutable } from "array-move";

import React, { useEffect, useMemo, useState } from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

import FileChonky from "./chonky/index";
import { Modal, Row, Col, Card, Divider, Input } from "antd";

import { useDispatch } from "react-redux";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import { fileManagerActions } from "../store";
import { LocalImage } from "./ImageUtil";
// import debounce from "lodash.debounce";

export default function UploadFile(props) {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  const { productItem } = props;

  const imageArray = productItem?.images ? productItem.images : [];

  const [images, setImages] = useState(imageArray);

  const onSelected = (url) => {
    setImages([
      ...images,
      {
        img: url,
        alt: null,
      },
    ]);
    setShow(!show);
  };
  const showWindow = () => {
    setShow(!show);
  };

  const removeImage = (index) => {
    const arr = [...images];
    arr.splice(index, 1);
    setImages(arr);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setImages(arrayMoveImmutable(images, oldIndex, newIndex));
  };

  const editAlt = (itemIndex, e) => {
    const arr = [...images];
    const arrEdit = arr.map((obj, index) => {
      if (index === itemIndex) {
        return { ...obj, alt: e.target.value };
      }
      return obj;
    });
    setImages(arrEdit);
    // editAltDebounce(arrEdit);
  };

  // const editAltDebounce = useMemo(() => debounce((arrEdit) => {
  //   setImages(arrEdit);
  // }, 3000), []);

  useEffect(() => {
    dispatch(fileManagerActions.setUrlImageList(images));
  }, [images]);

  const SortableItem = SortableElement(({ value }) => (
    <Col style={{ cursor: "pointer" }}>
      <Card
        hoverable
        actions={[
          <button
            className="ant-btn ant-btn-default"
            onClick={() => {
              removeImage(value.index);
            }}
          >
            <DeleteOutlined /> &nbsp; Xóa
          </button>,
        ]}
      >
        <LocalImage src={value.image} preview={false} style={{ objectFit: "contain" }} width={"100%"} height={200} />
        <br />
        <br />
        <Input
          placeholder="Nhập alt"
          width={250}
          size="small"
          defaultValue={value.alt}
          onBlur={(e) => {
            editAlt(value.index, e);
          }}
        />
      </Card>
    </Col>
  ));

  const SortableList = SortableContainer(({ items }) => {
    return (
      <Row gutter={[12, 12]}>
        {items.map((value, index) => (
          <SortableItem key={`item-${index}`} index={index} value={{ index, image: value.img, alt: value.alt }} />
        ))}
      </Row>
    );
  });

  return (
    <>
      {images.length > 10 ? null : (
        <>
          <div>
            <div onClick={showWindow} style={{ cursor: "pointer" }}>
              <div className="ant-upload ant-upload-select ant-upload-select-picture-card">
                <span tabIndex={0} className="ant-upload" role="button">
                  <div>
                    <span role="img" aria-label="plus" className="anticon anticon-plus">
                      <PlusOutlined />
                    </span>
                    <div style={{ marginTop: "8px" }}>Tải ảnh lên</div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </>
      )}

      <Divider />
      <div>
        <SortableList items={images} onSortEnd={onSortEnd} axis="xy" />

        {show && (
          <Modal
            title=""
            visible={show}
            width={1300}
            style={{ top: 20 }}
            okButtonProps={{
              disabled: true,
            }}
            onCancel={() => {
              setShow(false);
            }}
            destroyOnClose={true}
          >
            <div style={{ padding: "15px" }}>
              <FileChonky onSelected={onSelected} />
              <br />
            </div>
          </Modal>
        )}
      </div>
    </>
  );
}
